import React from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../../../store/app'
import { addNocProvider } from '../../../../store/NocProviderSlice'
import FormNocProvider from './FormNocProvider'
import { Form } from 'antd'

const AddNocProvider: React.FC<any> = ({
    getList,
    totalData
}) => {
    const dispatch: AppDispatch = useDispatch()
    const [form] = Form.useForm();
    const handleAddSubmit = (data: any) => {
        dispatch(addNocProvider(data))
            .then(() => {
                getList();
            })
            .catch((e: any) => {
                console.warn(e)
            })
    }
    return (
        <FormNocProvider
            form={form}
            handleAddSubmit={handleAddSubmit}
            mode={'add'}
            totalData={totalData}
        />
    )
}

export default AddNocProvider